import { render, staticRenderFns } from "./ModifyDiscounts.vue?vue&type=template&id=34878d2e&scoped=true"
import script from "./ModifyDiscounts.vue?vue&type=script&lang=ts"
export * from "./ModifyDiscounts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34878d2e",
  null
  
)

export default component.exports